export default __webpack_public_path__ + "static/media/espe_logo.e3f24c1e.png";